/* eslint-disable no-unused-vars */
import { useSignal } from '@preact/signals-react';
import { useSelector } from 'react-redux';
import { CustomFilter, Loader } from 'components';
import ApplicationsTable from './ApplicationsTable';
import { useFacade } from './useFacade';
import { isPublisherRole } from 'store/selectors';

import * as S from './ApplicationsList.styled';

export default function ApplicationsList({ appList = [] }) {
  const isPublisher = useSelector(isPublisherRole);
  const {
    foundedApps,
    searchValue,
    handleInputSearchValue,
    setSearchValue,
    setFilterState,
    filterState,
    appTypeFilter,
    setAppTypeFilter,
  } = useFacade(appList, isPublisher);
  const isRedirect$ = useSignal(false);

  return (
    <S.Container>
      {isRedirect$.value && <Loader.Global delay={0} />}
      <CustomFilter
        searchValue={searchValue}
        searchOnChange={handleInputSearchValue}
        clearSearchValue={() => setSearchValue('')}
        handleChangeFilterState={setFilterState}
        filterState={filterState}
        appTypeFilterState={appTypeFilter}
        handleChangeAppTypeFilter={setAppTypeFilter}
        hideAppTypeFilter={isPublisher}
      />
      <ApplicationsTable
        appList={foundedApps}
        isRedirect$={isRedirect$}
        searchValue={searchValue}
      />
    </S.Container>
  );
}
